import { allpeepNoPayloadEndpoint, allpeepPayloadEndpoint } from './helpers.js';
export const jams = (rawClient, eventSource) => {
    return {
        list: allpeepNoPayloadEndpoint(rawClient, '/jams'),
        state: allpeepNoPayloadEndpoint(rawClient, '/jams/:id/state'),
        close: allpeepNoPayloadEndpoint(rawClient, '/jams/:id/close', 'put'),
        token: allpeepNoPayloadEndpoint(rawClient, '/jams/:id/token'),
        muteParticipant: allpeepPayloadEndpoint(rawClient, '/jams/:id/mute-participant'),
        waitingRoom: {
            listen: eventSource('/jams/:id/waiting-room'),
            join: eventSource('/jams/:id/waiting-room', 'post'),
            admit: allpeepNoPayloadEndpoint(rawClient, '/jams/:id/waiting-room/:profileId/admit', 'post'),
        },
        events: {
            list: allpeepNoPayloadEndpoint(rawClient, '/jams/:id/events'),
            create: allpeepPayloadEndpoint(rawClient, '/jams/:id/events'),
            attendance: allpeepNoPayloadEndpoint(rawClient, '/jams/:id/events/attendance'),
            exportAttendance: async ({ id }) => {
                const response = await rawClient.get(`/jams/${id}/events/attendance/export`);
                if (!response.ok) {
                    throw { ...(await response.json()), status: response.status };
                }
                return response.text();
            },
        },
        recordings: {
            start: allpeepNoPayloadEndpoint(rawClient, '/jams/:id/recordings', 'post'),
            stop: allpeepNoPayloadEndpoint(rawClient, '/jams/:id/recordings/stop', 'put'),
            observerLink: allpeepNoPayloadEndpoint(rawClient, '/jams/:id/recordings/observer-link', 'get'),
        },
        streams: {
            get: allpeepNoPayloadEndpoint(rawClient, '/jams/:id/streams'),
            start: allpeepPayloadEndpoint(rawClient, '/jams/:id/streams', 'post'),
            stop: allpeepNoPayloadEndpoint(rawClient, '/jams/:id/streams/stop', 'put'),
        },
    };
};
